import React, { useRef } from 'react';
import { RestoredAdDrawer } from '@/components/Ad/RestoredDrawer';
import { AdStatus } from '@/types';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { StatusCard } from '@/components/Ad/Status/StatusCard';
import { PaymentFlow } from '@/components/Ad/Status/PaymentFlow';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { QUERY } from '@/constants/common';
import {
  PayByBalancePopupRef,
  PayByBalancePopup,
} from '@/components/Ad/Status/PayByBalancePopup';
import {
  ProlongByBalancePopup,
  ProlongByBalancePopupRef,
} from '@/components/Ad/Status/ProlongByBalancePopup';

interface StatusProps {
  status: AdStatus;
  isAuthor: boolean;
}

export const Status: React.FC<StatusProps> = ({ status, isAuthor }) => {
  const [isPaymentFlowOpen, paymentFlowToggle] = useToggleOpenState(
    QUERY.awaitingPayment
  );

  const [isRestoredDrawerOpen, toggleRestoredDrawer] = useToggleOpenState(
    isAuthor ? QUERY.paidServices : false
  );
  const payByBalancePopupRef = useRef<PayByBalancePopupRef>(null);
  const prolongByBalancePopupRef = useRef<ProlongByBalancePopupRef>(null);

  const handlePayByBalancePopupOpen = () => {
    payByBalancePopupRef.current?.toggle();
  };

  const handleProlongByBalancePopupOpen = () => {
    prolongByBalancePopupRef.current?.toggle();
  };

  return (
    <>
      <StatusCard
        status={status}
        isAuthor={isAuthor}
        onSuccess={toggleRestoredDrawer}
        paymentFlowToggle={paymentFlowToggle}
        payByBalancePopupToggle={handlePayByBalancePopupOpen}
        prolongByBalancePopupToggle={handleProlongByBalancePopupOpen}
      />

      <PaymentFlow
        isOpen={isPaymentFlowOpen}
        close={() => paymentFlowToggle(false)}
      />

      <PayByBalancePopup
        ref={payByBalancePopupRef}
        paymentFlowToggle={paymentFlowToggle}
        dataTestId={AdPageTestIds.statusBanner.payByBalancePopup}
      />

      <RestoredAdDrawer
        isOpen={isRestoredDrawerOpen}
        toggle={toggleRestoredDrawer}
      />

      <ProlongByBalancePopup
        ref={prolongByBalancePopupRef}
        onSuccess={toggleRestoredDrawer}
        dataTestId={AdPageTestIds.statusBanner.prolongByBalancePopup}
      />
    </>
  );
};
